import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getLandingPageCategoriesData } from '../Api/landingPageSlice'

// Higher-Order Component
const withCategoriesData = (WrappedComponent) => {
	return (props) => {
		const dispatch = useDispatch()
		const { categories } = useSelector((state) => state.landingPage)

		useEffect(() => {
			// Fetch categories data only when the component mounts
			dispatch(
				getLandingPageCategoriesData({
					type: 'category',
					//here we have to add categoryType:"66f3ed1abb3ed6ef16353e62" which will give us top categories
				})
			)
		}, [])

		// If you need loading or error handling, you can add it here
		return <WrappedComponent {...props} categories={categories} />
	}
}

export default withCategoriesData
